import formReducer from 'redux-form/lib/reducer';
import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import audioSegments from './audioSegments';
import browser from './browser';
import clipper from './clipper';
import clipSelection from './clipSelection';
import compliance from './compliance';
import episodePreview from './episodePreview';
import episode from './episode';
import episodes from './episodes';
import errorModal from './errorModal';
import localStorage from './localStorage';
import money from './money';
import onboarding from './onboarding';
import pageMetadata from './pageMetadata';
import partnerAnalytics from './partnerAnalytics';
import podcast from './podcast';
import podcastAnalytics from './podcastAnalytics';
import podcastEditor from './podcastEditor';
import playbackDurationTracking from './playbackDurationTracking';
import playbackPosition from './playbackPosition';
import recorder from './recorder';
import resetPassword from './resetPassword';
import search from './search';
import sourceAudio from './sourceAudio';
import station from './station';
import stations from './stations';
import transcriptions from './transcriptions';
import unsavedChangesTracker from './unsavedChangesTracker';
import user from './user';
import tutorial from './tutorial';
import waveArchive from './waveArchive';
import supportersScreenReducer from './screens/SupportersScreen/duck/reducers';
import supportersCancelScreenReducer from './screens/SupportersCancelScreen/duck/reducers';
import loginPodcastNetworkScreenReducer from './screens/LoginPodcastNetworkScreen/modules/store/reducers';
import settingsScreenReducer from './screens/SettingsScreen/duck/reducers';
import preDistributionModalScreenReducer from './screens/PreDistributionModalScreen/duck/reducers';
import podcastReducer from './store/global/podcast/reducers';
import dashboardScreenReducer from './screens/DashboardScreen/duck/reducers';
import coverArtModalScreenReducer from './screens/CoverArtModalScreen/duck/reducers';
import adAdvertiserCreatePaymentScreenReducer from './screens/AdAdvertiserCreatePaymentScreen/modules/store/reducers';
import episodeEditorScreenReducer from './screens/EpisodeEditorScreen/duck';
import splitSegmentAudioModalScreenReducer from './screens/SplitSegmentAudioModalScreen/duck';
import adRecordingModalScreenReducer from './screens/AdRecordingModalScreen/duck';
import episodesScreenReducer from './screens/EpisodesScreen/duck';

import { _podcastReducer } from './store/reducers.ts';
import { _episodesByIdReducer } from './store/_episodesById/reducers';

export default {
  adAdvertiserCreatePaymentScreen: adAdvertiserCreatePaymentScreenReducer,
  adRecordingModalScreen: adRecordingModalScreenReducer,
  episodesScreen: episodesScreenReducer,
  coverArtModalScreen: coverArtModalScreenReducer,
  dashboardScreen: dashboardScreenReducer,
  episodeEditorScreen: episodeEditorScreenReducer,
  loginPodcastNetworkScreen: loginPodcastNetworkScreenReducer,
  preDistributionModalScreen: preDistributionModalScreenReducer,
  settingsScreen: settingsScreenReducer,
  splitSegmentAudioModalScreen: splitSegmentAudioModalScreenReducer,
  supportersScreen: supportersScreenReducer,
  supportersCancelScreen: supportersCancelScreenReducer,
  _podcast: _podcastReducer,
  _episodesById: _episodesByIdReducer,
  global: combineReducers({
    podcast: podcastReducer,
  }),
  audioSegments,
  browser,
  clipper,
  clipSelection,
  compliance,
  episodePreview,
  episode,
  episodes,
  errorModal,
  form: formReducer,
  localStorage,
  money,
  onboarding,
  pageMetadata,
  partnerAnalytics,
  playbackDurationTracking,
  playbackPosition,
  podcast,
  podcastAnalytics,
  podcastEditor,
  recorder,
  resetPassword,
  routing: routerReducer,
  search,
  sourceAudio,
  station,
  stations,
  transcriptions,
  unsavedChangesTracker,
  user,
  tutorial,
  waveArchive,
};
